export default __webpack_public_path__ + "static/media/conector.34215a61.svg";